var _style, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStage4FullBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 199 199",
    style: {
      enableBackground: "new 0 0 199 199"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{opacity:0.55;fill:url(#SVGID_00000119110228869036840380000007907262081298754192_);}\r\n\t.st2{opacity:0.55;fill:url(#SVGID_00000013170355888064391830000005555747685780106658_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.4882,
    y1: 99.5,
    x2: 198.5118,
    y2: 99.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0008044369,
    style: {
      stopColor: "#EB812B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9961,
    style: {
      stopColor: "#E11876"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 99.5,
    cy: 99.5,
    r: 99
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034075026541120322180000012593845978307121583_",
    gradientUnits: "userSpaceOnUse",
    x1: -2386.8352,
    y1: 2130.2332,
    x2: -2218.0701,
    y2: 2130.2332,
    gradientTransform: "matrix(-0.5047 0.5047 0.7071 0.7071 -2553.9653 -238.1459)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4E4E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2678,
    style: {
      stopColor: "#E6E2E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8ECF0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.55,
      fill: "url(#SVGID_00000034075026541120322180000012593845978307121583_)"
    },
    d: "M102.5,148.7L157,94.2 c8.4-8.4,8.4-22.2,0-30.7l0,0c-8.4-8.4-22.2-8.4-30.7,0L71.8,118c-8.4,8.4-8.4,22.2,0,30.7l0,0C80.2,157.2,94,157.2,102.5,148.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150811628826132622950000005635164434871490746_",
    gradientUnits: "userSpaceOnUse",
    x1: -407.9343,
    y1: 665.6263,
    x2: -239.1691,
    y2: 665.6263,
    gradientTransform: "matrix(0.3012 0.3012 -0.7071 0.7071 644.7535 -249.9186)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4E4E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2678,
    style: {
      stopColor: "#E6E2E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8ECF0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.55,
      fill: "url(#SVGID_00000150811628826132622950000005635164434871490746_)"
    },
    d: "M71.4,148.7l-20.1-20.1 c-8.4-8.4-8.4-22.2,0-30.7l0,0c8.4-8.4,22.2-8.4,30.7,0L102,118c8.4,8.4,8.4,22.2,0,30.7l0,0C93.6,157.2,79.8,157.2,71.4,148.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStage4FullBadge);
export default __webpack_public_path__ + "static/media/stage4-full_Badge.3e93b401bab17c334833d157a340ce32.svg";
export { ForwardRef as ReactComponent };